export default "__VITE_ASSET__xfjBDH$1__"